export const REDIRECT_TO_QUERY_PARAM = 'rd';
export const OTHER_BILLS_SOURCE = 'other';
